<template>
  <article class="container-fluid box-container pb-3 mt-1 mb-4">
    <div class="row">
      <div class="col">
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <div class="row p-3">
            <div
              class="col-12"
              :class="[searched ? 'col-md-5 border-divider' : 'col-md-6']"
            >
              <div class="mb-4">
                <em
                  class="fas fa-user-plus rounded-circle shadow text-orange p-2 mr-2"
                />
                <span class="box-title">Añadir Estudiante</span>
              </div>
              <div class="mb-4 mb-md-0">
                <ValidationProvider
                  ref="studentSieValidator"
                  v-slot="{ errors }"
                  rules="required|integer"
                >
                  <CustomInput
                    v-model="studentSie"
                    :error="errors[0]"
                    placeholder="Escriba número de SIE"
                    custom-error-msg="Favor escriba número de SIE."
                  />
                </ValidationProvider>
              </div>
            </div>
            <div
              v-if="searched"
              class="col-12 col-md ml-0 ml-md-3 mt-4 mt-md-0 mb-4 mb-md-0"
            >
              <CustomBalloon :class="balloonClasses" text="Resultado" />
              <div v-if="student">
                <div>
                  <span class="box-result-field-label mr-1">Nombre:</span>
                  <span class="box-result-field-value">
                    {{ student.firstName }} {{ student.lastName }}
                  </span>
                </div>
                <div>
                  <span class="box-result-field-label mr-1">Edad:</span>
                  <span class="box-result-field-value">{{ student.age }}</span>
                </div>
                <div>
                  <span class="box-result-field-label mr-1">SIE:</span>
                  <span class="box-result-field-value">
                    {{ student.studentId }}
                  </span>
                </div>
                <div>
                  <span class="box-result-field-label mr-1">Registro:</span>
                  <span class="box-result-field-value">
                    {{
                      student.mipeStudent && student.mipeStudent.regStudentId
                    }}
                  </span>
                </div>
                <div>
                  <span class="box-result-field-label mr-1">Estatus:</span>
                  <span class="box-result-field-value">
                    {{ student.status }}
                  </span>
                </div>
              </div>
              <div v-else class="box-result-empty">
                No se encontró un estudiante con los criterios de búsqueda
                entrados.
              </div>
            </div>
            <div
              v-if="student"
              class="col-12 col-md d-flex justify-content-center justify-content-md-end align-items-end"
            >
              <ActionButton
                id="action-btn"
                class="mr-3"
                variant="outline-danger"
                i="fas fa-times-circle"
                text="Cancelar"
                @click="cancel"
              />
              <ActionButton
                id="action-btn"
                :disabled="isLoading || !student"
                text="Añadir"
                variant="success"
                i="fas fa-file-plus"
                @click="add"
              />
            </div>
            <div
              v-else
              class="col-12 col-md d-flex justify-content-end align-items-end"
            >
              <ActionButton
                id="action-btn"
                class="mr-3"
                variant="outline-danger"
                i="fas fa-times-circle"
                text="Cancelar"
                @click="cancel(true)"
              />
              <ActionButton
                class="full-width-btn"
                text="Buscar"
                variant="success"
                i="fa fa-search"
                @click="handleSubmit(doSearch)"
              />
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </article>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomBalloon from 'custom-balloon';
import studentService from '@/modules/student/api';
import alertMixin from '@/mixin/alert.mixin';
import loadingMixin from '@/mixin/loading.mixin';
import StudentStatuses from '@/utils/constants/student/studentStatuses';
import { assignStudentToTeacher } from '@/modules/alternative-location-management/api';

export default {
  name: 'AddStudent',
  mixins: [alertMixin, loadingMixin],
  components: {
    ActionButton,
    CustomInput,
    CustomBalloon,
  },
  props: {
    collections: {
      type: Object,
      required: true,
    },
    teacherId: {
      type: Number,
      required: true,
    },
    schoolAlternativeLocationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      studentSie: null,
      student: null,
      searched: false,
      isLoading: false,
    };
  },
  methods: {
    add() {
      const allowedStudentStatuses = [
        StudentStatuses.Elegible,
        StudentStatuses.Servido,
      ];
      if (!allowedStudentStatuses.includes(this.student.statusId)) {
        this.ShowToast(
          'Alerta',
          this.collections.resources['R01210005'],
          'error'
        );
        return;
      }

      this.isLoading = true;

      assignStudentToTeacher({
        assignToId: this.teacherId,
        studentSieId: Number(this.student.studentId),
        schoolAlternativeLocationId: this.schoolAlternativeLocationId,
      })
        .then((res) => {
          this.isLoading = false;
          if (res.status == 200) {
            this.$emit('on-added', this.student);
            this.ShowToast(
              'Confirmación',
              this.collections.resources['R01210008'],
              'success'
            );
            this.cancel();
          }
        })
        .catch((err) => {
          this.isLoading = false;
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    cancel(emit) {
      this.studentSie = null;
      this.student = null;
      this.searched = false;
      this.$refs.studentSieValidator.reset();
      if (emit) this.$emit('cancel', false);
    },
    async doSearch() {
      try {
        const { data } = await studentService.getStudentDetailsBySie(
          this.studentSie,
          false
        );
        this.student = data.studentId ? data : null;
        this.searched = true;
      } catch (ex) {
        this.student = null;
        this.ShowToast('Alerta', ex.response.data.message, 'error');
      }
    },
  },
  watch: {
    isLoading(value) {
      if (value) {
        this.ShowWait();
      } else {
        this.HideWait();
      }
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    balloonClasses() {
      return ['mb-2', { 'w-40': !this.isMobile }];
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.box-container {
  border: 5px solid map.get($colors, 'gray-9');
  border-radius: 5px;
}
.box-title {
  font: Bold 1.125rem Lato;
}
.border-divider:after {
  content: '';
  position: absolute;
  top: 50px;
  right: 0;
  height: 50px;
  border-right: 1px solid map.get($colors, 'gray-4');
}
.box-result-empty {
  width: 50%;
  color: map.get($colors, 'gray-3');
  text-align: center;
}
.box-result-field-label {
  color: map.get($colors, 'gray-6');
}
.box-result-field-value {
  font-weight: bold;
}
.box-divider {
  background-color: map.get($colors, 'gray-9');
}
.box-divider-group:before {
  content: '';
  position: absolute;
  top: 50%;
  right: 0;
  width: 100%;
  border-bottom: 1.5px solid map.get($colors, 'gray-2');
}
.box-item-border-bottom:not(:last-child) {
  border-bottom: 5px solid map.get($colors, 'gray-9');
}
.delete-btn {
  margin-right: 15px;
}
.callout-expanded-container {
  background-color: map.get($colors, 'white');
  border: 5px solid map.get($colors, 'gray-9');
  border-radius: 5px;
  padding: 15px 30px;
}
.callout-expanded-item {
  background-color: map.get($colors, 'secondary-3');
}
.callout-expanded-item:not(:first-child) {
  margin-top: 10px;
}
::v-deep .balloon-container {
  color: map.get($colors, 'white') !important;
  background-color: map.get($colors, 'gray-2') !important;
}
::v-deep .student-search-alert-error {
  height: 0;
}
::v-deep .balloon-container.dark-gray-bg {
  background-color: map.get($colors, 'gray-7') !important;
}
@media (max-width: 765px) {
  ::v-deep .full-width-btn {
    width: 100%;
    margin-top: 15px;
  }
  ::v-deep #action-btn {
    width: 50%;
  }
  ::v-deep .delete-btn {
    margin-right: 0;
  }
  .box-result-empty {
    width: 100%;
  }
  .border-divider:after {
    content: '';
    position: absolute;
    top: 93px;
    right: 15px;
    width: 90%;
    height: 0;
    border-right: none;
    border-bottom: 1px solid map.get($colors, 'gray-4');
  }
  ::v-deep .delete-student-btn {
    width: 100%;
  }
}
</style>
